import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ||
  'https://4jbhzumjk7.execute-api.us-east-2.amazonaws.com/prod';

export interface StrategyBreakdown {
  strategy: string;
  n: number;
  win_rate_pct: number;
  total_pnl: number;
  expectancy_per_trade: number;
}

export interface OutcomeBreakdown {
  trades: number;
  total_pnl: number;
}

// Scenario 1 (baseline) -- simple flat metrics
export interface FlatHeadlineMetrics {
  n_trades: number;
  win_rate_pct: number;
  total_pnl: number;
  expectancy_per_trade: number;
}

// Scenario 2 (sweep) -- nested per-threshold metrics
export interface PerThresholdMetrics {
  n_taken: number;
  skipped: number;
  win_rate_pct: number;
  total_pnl: number;
  expectancy_per_taken: number;
  full_universe_expectancy: number;
}

export interface SweepHeadlineMetrics {
  thresholds_tested: number[];
  baseline_comparison: FlatHeadlineMetrics;
  per_threshold: Record<string, PerThresholdMetrics>;
}

export type HeadlineMetrics = FlatHeadlineMetrics | SweepHeadlineMetrics;

export function isSweepMetrics(m: HeadlineMetrics): m is SweepHeadlineMetrics {
  return 'thresholds_tested' in m;
}

export interface BacktestScenario {
  scenario_id: string;
  title: string;
  hypothesis: string;
  methodology: string;
  headline_metrics: HeadlineMetrics;
  by_strategy: StrategyBreakdown[];
  by_outcome: Record<string, OutcomeBreakdown>;
  conclusion: string;
  caveats: string[];
  run_date: string;
  display_order: number;
}

export const backtestScenariosService = {
  async list(token: string): Promise<BacktestScenario[]> {
    const res = await axios.get(`${API_BASE_URL}/backtest-scenarios`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const scenarios = res.data.scenarios as BacktestScenario[];
    return scenarios.sort((a, b) => a.display_order - b.display_order);
  },
};
